import { ModelBase } from '../abstract/model-base.model';

export class AiSettings extends ModelBase {

    static override CLASS_NAME: string = 'AiSettings';

    private _enableAgentWebSearch!: boolean;
    private _enableBankQualification!: boolean;
    private _enableBankRuleFinder!: boolean;
    private _enablePartnerContextEnrichment!: boolean;

    public get enableAgentWebSearch(): boolean {
        return this._enableAgentWebSearch;
    }

    public set enableAgentWebSearch(value: any) {
        this._setValue('_enableAgentWebSearch', value, 'boolean');
    }

    public get enableBankQualification(): boolean {
        return this._enableBankQualification;
    }

    public set enableBankQualification(value: any) {
        this._setValue('_enableBankQualification', value, 'boolean');
    }

    public get enableBankRuleFinder(): boolean {
        return this._enableBankRuleFinder;
    }

    public set enableBankRuleFinder(value: any) {
        this._setValue('_enableBankRuleFinder', value, 'boolean');
    }

    public get enablePartnerContextEnrichment(): boolean {
        return this._enablePartnerContextEnrichment;
    }

    public set enablePartnerContextEnrichment(value: any) {
        this._setValue('_enablePartnerContextEnrichment', value, 'boolean');
    }
}
